// @ts-nocheck

import styled, { css } from 'styled-components';

import * as Backgrounds from '../assets/img/backgrounds';

export const LayoutDesktopStyle = styled.div`
  *:not(input) {
    user-select: none;
  }

  &.opened {
    overflow: hidden;
    touch-action: none;
  }

  .content {
    position: relative;
    .bet-list,
    .event-list {
      position: relative;
      height: 100%;
      width: 100%;
      margin: 0 auto;
      padding: 0;
      border-radius: 0;
    }

    .width-container {
      min-height: 100%;
    }
  }

  .centered-message-betting {
    position: relative;
    text-align: center;
    margin: 40vh 10px 55vh;
    transform: translateY(-50%);
  }
`;

const randomBackground =
  Backgrounds[Object.keys(Backgrounds)[Math.floor(Math.random() * Object.keys(Backgrounds).length)]];

export const DesktopStyle = css`
  body {
    &:before {
      content: '';
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;

      background: url(${randomBackground});
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      background-color: #070e14;
    }
  }

  #page {
    padding-top: 0;
  }

  #inner-wrap,
  #page {
    -webkit-transform: none;
    -moz-transform: none;
    -ms-transform: none;
    -o-transform: none;
    transform: none;
  }

  #page-content .loading {
    display: block;
    font-size: 15px;
    width: 100%;
    text-align: center;
    font-weight: 400;
  }

  #page-content .hidden {
    display: none;
  }

  #page section {
    overflow: visible;
  }

  #innercontainer {
    min-height: 400px;
  }

  .betting {
    .container {
      &:before,
      &:after {
        content: '';
        display: table;
        clear: both;
      }
    }
  }
`;
